import React from 'react';

import { connect } from "react-redux"//联系store的组件
import evn from "./../../../actions/index"//action的所有事件
import $ from "jquery"
import zh_CN from 'antd/lib/locale-provider/zh_CN';
import "./CaseDetailsInfo.css"//引入样式
import { Layout, Table, Icon, Switch, Tabs, Radio, Button, message, Modal, Row, Col, Form, Input, LocaleProvider, Tooltip  } from 'antd';//引入antd组件
import { data_Url, Hcurl, tabletext } from "./../../../constants/index"//获取公共路径
import EventJS from "./../../../assets/PubJs/hcPub"//所有事件
import createHistory from 'history/createHashHistory';//路由切换地址
import PhotoView from './photoView';
const history = createHistory();//定义history路由
const TabPane = Tabs.TabPane;

let caseType = '';//投诉举报
let column = 8;//每行三列
let isCompromise = '';//和解，调解
let fromType = '';//页面来源
let _activeKey = '1';
let isHide = '1';//是否显示关联业务单
let ciSubState = '';//拒绝和解判断

//组件对象
let cistate = '';//登记单主状态
let cicode = '';//登记单Code
let _FlowCommon = null;
let _TransferInfo = null;//流转信息
let _OthersInfo = null;//其他信息
let _DealInfo = null;//受理信息
let baseInfoData = null;//基本信息
let _NoDealInfo = null;//不受理信息
let _LogoInfo = null;//日志留痕
let _RefusInfo = null;//拒绝和解

let _App = null;
class App extends React.Component {
    state = {
        caseID: 0,
        caseType: '投诉',
        result: '',//不受理时增加不受理Tab
        disabled: false,//咨询时禁用tab
        showbslInfo: false,//显示不受理信息
        fromType: this.props.fromType,//页面来源
        activeKey: _activeKey,//默认tab
        num: 0,
    };

    componentWillReceiveProps(e) {
        fromType = e.fromType;
        var _caseID = this.state.caseID;
        //console.log('num', this.state.num)
        this.setState({ caseID: e.caseId, num: 1, activeKey: '1' }, () => {
            this.handleData();
        })
    }
    //组件完成
    componentDidMount() {
        _FlowCommon = this;
    }
    componentWillMount() {
        fromType = this.props.type;
        //console.log('num', this.state.num)

        this.setState({ caseID: this.props.cid, num: 1, activeKey: '1' }, () => {
            this.handleData();
        })
    }
    componentWillUnmount() {

    }
    //获取主要信息
    handleData() {
        if (fromType == 'import' || fromType == 'CompanyTransact') {
            column = 12;
        }
        else
            column = 8;
        if (this.state.caseID != 0) {
            var arr = new Array();
            let t = JSON.parse(localStorage.userInfo)
            let token = t.token
            $.ajax({
                url: data_Url + 'WisdomAPI.ashx',
                type: "post",
                headers: {
                    "token": token
                },
                dataType: "jsonp",
                jsonp: "callback",
                ansyc: false,
                cache: false,
                timeout: 360000,
                jsonpCallback: "successcallback",
                data: {
                    doType: "GetCaseInfoDtsByID",
                    ID: _FlowCommon.state.caseID
                },
                success: function (result) {
                    //console.log('CaseInfo', result);
                    if (result != null && result != '') {
                        console.log(result, 'result');
                        //result = JSON.parse(result);
                        baseInfoData = result;
                        caseType = result.CI_Type;
                        cicode = result.CI_Code;
                        isCompromise = result.CI_IsCompromise;
                        cistate = result.CI_State;
                        isHide = result.IsHide;
                        ciSubState = result.CI_SubState;
                        if (result.CI_Type == '咨询') {
                            _FlowCommon.setState({ disabled: true });
                        }
                        else {
                            if (fromType == 'audit')
                                _FlowCommon.setState({ disabled: true });
                            else
                                _FlowCommon.setState({ disabled: false });
                        }
                        if (result.CI_State == '不受理')
                            _FlowCommon.setState({ showbslInfo: true });
                        else
                            _FlowCommon.setState({ showbslInfo: false });
                    }
                },
                error: function () {
                    history.push({ "pathname": "/Login/LoginMain/LoginEntry" })
    
                }
            })
            setTimeout(() => {  
                try {
                    $.ajax({
                        url: Hcurl + '/CaseLog/WriteOperationLog',
                        type: "post",
                                            headers: {
                                                "token": EventSet.getUserInfo()['token']
                                            },
                        data: {
                            Log_UserCode: EventJS.getUserInfo().CU_Code,
                            Log_UserIP: localStorage.getItem('userIp'),
                            Log_Content: "-",
                            //Log_Content: "查看登记单",
                            Log_CaCode: cicode,
                            Log_Method: '查看',
                        },
                        success: function (result) {
                            console.log(cicode, 'cicode');

                        },
                        error: function () {
                            history.push({ "pathname": "/Login/LoginMain/LoginEntry" })
                        }
                    })
                }
                catch (ex) { }
            }, 500)
        }
    }
    //tab页切换
    onChange = (activeKey) => {
        console.log(activeKey)
        this.setState({ activeKey });
        _activeKey = activeKey;
        switch (_activeKey) {

            case "2":
                //_TransferInfo.loadData();
                break;
            case "3":
                // _DealInfo.loadData();
                break;
            case "4":
                //_OthersInfo.loadData();
                break;
        }
    }
    //渲染组件
    render() {
        const { caseID } = this.state//业务登记单ID
        return (
            <div className="flowCommon">
                <LocaleProvider locale={zh_CN}>
                <Tabs type="card" defaultActiveKey="1" activeKey={this.state.activeKey} onChange={this.onChange}>
                    <TabPane tab="基本信息" key="1" >
                        <div style={{ height: '98%', overflow: 'auto' }}>
                            <BasicInfo CaseID={caseID} />
                        </div>
                    </TabPane>
                    <TabPane forceRender={true} disabled={this.state.disabled} tab="流程日志" key="2">
                        <div style={{ height: '98%', overflow: 'auto' }}>
                            <TransferInfo CaseID={caseID} />
                        </div>
                    </TabPane>
                    {ciSubState == "拒绝和解" ? <TabPane forceRender={true} disabled={this.state.disabled} tab="拒绝和解" key="6">
                        <div style={{ height: '98%', overflow: 'auto' }}>
                            <RefusInfo CaseID={caseID} />
                        </div>
                    </TabPane> : ''}
                        {ciSubState != "拒绝和解"?(cistate == "回访中" || cistate == "已归档"||ciSubState == '待审批')  ? <TabPane forceRender={true} disabled={this.state.disabled} tab="办理信息" key="3">
                            <div style={{ height: '98%', overflow: 'auto' }}>
                                <DealInfo CaseID={caseID} />
                            </div>
                        </TabPane> : <TabPane forceRender={true} disabled={this.state.disabled} tab="办理信息" key="3">
                            <div style={{ height: '98%', overflow: 'auto',textAlign:"center",margin:'10px 0px 0px',padding:'100px 0px 6px' }}>
                            {/*  */}
                            {/* <img src='./../'></img> */}
                                <img src={ require('./../../../assets/images/Unlicened.png') } />
                                <p style={{verticalAlign:'top',margin:'20px 0 0 6px',fontSize:'16px',fontWeight:'bold'}}>
                                    当前没有办理信息
                                </p>
                                
                            </div>
                        </TabPane>:''}

                    <TabPane forceRender={true} disabled={this.state.disabled} tab="其它内容" key="4">
                        <div style={{ height: '98%', overflow: 'auto' }}>
                            <OthersInfo CaseID={caseID} />
                        </div>
                    </TabPane>
                    {/* <TabPane  forceRender={true} disabled={this.state.disabled} tab="文书打印" key="7">
                        <div style={{ height: '98%', overflow: 'auto' }}>

                        </div>
                    </TabPane>*/}
                    <TabPane forceRender={true} disabled={this.state.disabled} tab="日志留痕" key="5">
                        <div style={{ height: '98%', overflow: 'auto' }}>
                            <LogoInfo CaseID={caseID} />
                        </div>
                    </TabPane>

                </Tabs>
                </LocaleProvider>
            </div>
        );
    }
}
//基本信息
var _BasicInfo = null;
var basic_previewRef = null;
class BasicInfo extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            caseID: this.props.CaseID,
            basicInfoData: null,
            viewType: '简略信息',
            basic_previewData:[], //图片预览数据
        }
    }
    handleChange = (e) => {
        this.setState({ viewType: e.target.value })
    }
    componentWillReceiveProps(nextProps) {

        this.setState({ caseID: nextProps.CaseID })
        if (_FlowCommon.state.activeKey == '1')
            setTimeout(function () { _BasicInfo.loadData(); }, 10);
    }
    componentWillMount() {
        this.loadData();
    }
    componentDidMount() {
        _BasicInfo = this;
    }
    onReloadAttachs(files) {
        let _this =this
        // if (files != null && files != '') {
        //     const attachfiles = files.split(';');
        //     return (attachfiles.map(function (item, index) {
        //         return <a key={index} href={item} target='_blank' style={{ display: item.toString() == '' ? 'none' : 'inline' }} > {_this.fileName(item, ['doc', 'docx', 'xls', 'xlsx', 'pdf', 'jpg', 'jpeg', 'png', 'bmp', 'txt', 'JPG', 'gif', 'GIF', 'svg', 'rm', 'rmvb', 'mpeg', 'avi', 'mp4', '3gp', 'flv', 'wmv', 'swf', 'mpg', '3gp2', 'asf', 'mpeg1', 'mpeg2', 'mpeg3', 'mpeg4', 'h264', 'flv1', 'ppt', 'pptx', 'vsd', 'pot', 'pps', 'rtf', 'wps', 'et', 'dps', 'txt', 'epub', 'rar', 'rar5', 'zip', '7z','BMP','JFIF','bmp','jfif','ico','tif','webp'])}</a >
        //     }))
        // }

        const imgType = ['png', 'jpg', 'jpeg', 'bmp', 'gif']
        if (files != null && files != '') {
            const attachfiles = files.split(';');
            return (attachfiles.map((item, index) => {
                let flieArr = item.split('.');
                if (imgType.indexOf(flieArr[flieArr.length - 1].toLowerCase()) != -1) {
                    return <span style={{ color: "#038374", cursor: "pointer", display: item.toString() == '' ? 'none' : 'inline' }} key={index} onClick={() => this.imgClick(attachfiles)} >
                        {_this.fileName(item, ['doc', 'docx', 'xls', 'xlsx', 'pdf', 'jpg', 'jpeg', 'png', 'bmp', 'txt', 'JPG', 'gif', 'GIF', 'svg', 'rm', 'rmvb', 'mpeg', 'avi', 'mp4', '3gp', 'flv', 'wmv', 'swf', 'mpg', '3gp2', 'asf', 'mpeg1', 'mpeg2', 'mpeg3', 'mpeg4', 'h264', 'flv1', 'ppt', 'pptx', 'vsd', 'pot', 'pps', 'rtf', 'wps', 'et', 'dps', 'txt', 'epub', 'rar', 'rar5', 'zip', '7z','BMP','JFIF','bmp','jfif','ico','tif','webp'])}
                    </span >
                } else {
                    return <a key={index} href={item} target='_blank' style={{ display: item.toString() == '' ? 'none' : 'inline' }} > {_this.fileName(item, ['doc', 'docx', 'xls', 'xlsx', 'pdf', 'jpg', 'jpeg', 'png', 'bmp', 'txt', 'JPG', 'gif', 'GIF', 'svg', 'rm', 'rmvb', 'mpeg', 'avi', 'mp4', '3gp', 'flv', 'wmv', 'swf', 'mpg', '3gp2', 'asf', 'mpeg1', 'mpeg2', 'mpeg3', 'mpeg4', 'h264', 'flv1', 'ppt', 'pptx', 'vsd', 'pot', 'pps', 'rtf', 'wps', 'et', 'dps', 'txt', 'epub', 'rar', 'rar5', 'zip', '7z','BMP','JFIF','bmp','jfif','ico','tif','webp'])}</a >
                }
            }))
        }
    }

    imgClick = (attachfiles) => {
        this.setState({
            basic_previewData: attachfiles
        }, () => {
            basic_previewRef.show()
        })
    }

    onRenderContent(content) {
        try {
            if (content.indexOf('￥') >= 0 && content.indexOf('$') >= 0 && content.indexOf('￡') >= 0) {
                var str1 = content.substring(content.indexOf("￥") + 1, content.lastIndexOf("￥"));//平台账号
                var str2 = content.substring(content.indexOf("$") + 1, content.lastIndexOf("$"));//订单编号
                var str3 = content.substring(content.indexOf("￡") + 1, content.lastIndexOf("￡"));//投诉内容
                return <span><span>平台账号:{str1}</span><br /><span>订单编号:{str2}</span><br /><span>{str3}</span></span>
            }
            else return content;
        } catch (e) { return content; }
    }
    fileName(url, array) {
        url = url || "";
        let fileName = "";
        if (url) {
            array.forEach(keys => {
                if (url.indexOf(keys) > -1) {
                    fileName = url.substring(url.split('').map((item, index) => { if (item == '/') { return index } }).filter(item => { if (item) { return item } })[url.split('').map((item, index) => { if (item == '/') { return index } }).filter(item => { if (item) { return item } }).length - 1] + 1, url.indexOf(keys) - 1) + '.' + keys
                }
            })
        }
        return fileName;
    }
    loadData() {
        if (this.state.caseID != 0) {
            this.setState({ basicInfoData: baseInfoData })
        }
    }
    render() {
        const { basicInfoData } = this.state;
        return (
            <div>
                <Row>
                    <Col className="gutter-row" style={{ textAlign: 'center' }} span={24}>
                        <Radio.Group defaultValue={this.state.viewType} onChange={this.handleChange}>
                            <Radio.Button value="简略信息">简略信息</Radio.Button>
                            <Radio.Button value="详细信息">详细信息</Radio.Button>
                        </Radio.Group>
                    </Col>
                </Row>

                {basicInfoData != null ?
                    <div>

                        <Row justify="center" style={{ marginTop: 10 }}>
                            <Col span={column}><span style={{ fontWeight: 'bold', fontSize: 14 }}>系统信息</span><a></a></Col>
                        </Row>
                        <Row justify="center">
                            <Col span={column} className="gutter-row" ><span>登记编号：</span><span className="value" >{basicInfoData.CI_Code}</span></Col>
                            <Col span={column} className="gutter-row" ><span>登记时间：</span><span className="value">{basicInfoData.CI_RegTime}</span></Col>
                            <Col span={column} className="gutter-row" ><span>{basicInfoData.CI_Type}时间：</span><span className="value">{basicInfoData.CI_TypeTime}</span></Col>
                        </Row>
                        <Row>
                            <Col span={column} style={{ marginTop: 15, fontWeight: 'bold', fontSize: 14 }}><span>投诉人信息</span><a></a></Col>
                        </Row>
                        <Row justify="center">

                            <Col span={column} className="gutter-row" ><span>姓名：</span><span className="value">{basicInfoData.CI_UserName}</span></Col>
                            <Col span={column} className="gutter-row" ><span>性别：</span><span className="value">{basicInfoData.CI_UserSex}</span></Col>
                            <Col span={column} className="gutter-row" ><span>联系电话：</span><span className="value">{basicInfoData.CI_UserPhone}</span></Col>
                            <Col span={column} className="gutter-row" ><span>人员类别：</span><span className="value">{basicInfoData.UserSort}</span></Col>

                            <div style={{ display: (this.state.viewType == "详细信息" ? "block" : "none") }}>

                                <Col span={column} className="gutter-row" ><span>投诉人类型：</span><span className="value">{basicInfoData.UserType}</span></Col>
                                <Col span={column} className="gutter-row" ><span>来电号码：</span><span className="value">{basicInfoData.UserRingPhone}</span></Col>

                                <Col span={column} className="gutter-row" ><span>个人身份：</span><span className="value">{basicInfoData.UserIdentity}</span></Col>
                                <Col span={column} className="gutter-row" ><span>是否本地消费：</span><span className="value">{basicInfoData.CI_IsLocalConsum}</span></Col>

                                <Col span={column} className="gutter-row" ><span>国籍/地区：</span><span className="value">{basicInfoData.UserCountry}</span></Col>
                                <Col span={column} className="gutter-row" ><span>民族：</span><span className="value">{basicInfoData.UserNation}</span></Col>


                                <Col span={column} className="gutter-row" ><span>年龄：</span><span className="value">{basicInfoData.CI_UserAge}</span></Col>
                                <Col span={column} className="gutter-row" ><span>残疾人：</span><span className="value">{basicInfoData.CI_UserIsDisabled}</span></Col>

                                <Col span={column} className="gutter-row" ><span>工作单位：</span><span className="value">{basicInfoData.CI_UserWorkUnit}</span></Col>
                                <Col span={column} className="gutter-row" ><span>证件类型：</span><span className="value">{basicInfoData.UserCardType}</span></Col>

                                <Col span={column} className="gutter-row" ><span>证件号码：</span><span className="value">{basicInfoData.CI_UserCardNO}</span></Col>

                            </div>
                        </Row>
                        {basicInfoData.CI_Type=='无理由退货'?<Row>
                            <Col span={column} style={{ marginTop: 15, fontWeight: 'bold', fontSize: 14 }}><span>收款信息</span><a></a></Col>
                        </Row>:''}
                        
                        {basicInfoData.CI_Type=='无理由退货'&&basicInfoData.CI_CustomerCardType =='1'?<Row justify="center">
                            <Col span={column} className="gutter-row" ><span>收款方式：</span><span className="value" >银行卡</span></Col>
                            <Col span={column} className="gutter-row" ><span>银行卡号：</span><span className="value" style={{wordBreak:'break-all'}}>{basicInfoData.CI_BankCardNo}</span></Col>
                            <Col span={column} className="gutter-row" ><span>持卡人姓名：</span><span className="value" style={{wordBreak:'break-all'}}>{basicInfoData.CI_BankUserName}</span></Col>
                            <Col span={column} className="gutter-row" ><span>开户行：</span><span className="value">{basicInfoData.CI_BankName}</span></Col>
                        </Row>:''}
                        {basicInfoData.CI_Type=='无理由退货'&&basicInfoData.CI_CustomerCardType !='1'?<Row justify="center">
                            <Col span={column} className="gutter-row" ><span>收款方式：</span><span className="value" >支付宝</span></Col>
                            <Col span={column} className="gutter-row" ><span>支付宝账户：</span><span className="value" style={{wordBreak:'break-all'}}>{basicInfoData.CI_CustomerAlipayAccount}</span></Col>
                            <Col span={column} className="gutter-row" ><span>真实姓名：</span><span className="value"  style={{wordBreak:'break-all'}}>{basicInfoData.CI_BankUserName}</span></Col>
                        </Row>:''}

                        <Row>
                            <Col span={column} style={{ marginTop: 15, fontWeight: 'bold', fontSize: 14 }}><span>{basicInfoData.CI_Type}案件信息</span><a></a></Col>
                        </Row>
                        <Row justify="center">

                            <Col span={column} className="gutter-row" ><span>商品/服务名称：</span><span className="value">{basicInfoData.CI_ShopName}</span></Col>
                            <Col span={column} className="gutter-row" ><span>品牌/商标名称：</span><span className="value">{basicInfoData.CI_ShopBrandName}</span></Col>
                            <Col span={column} className="gutter-row" ><span>销售方式：</span><span className="value">{basicInfoData.CI_SellMethod}</span></Col>
                            <Col span={column} className="gutter-row" ><span>销售金额：</span><span className="value">{basicInfoData.CI_ShopMoney}元</span></Col>
                            <Col span={column} className="gutter-row" ><span>订单号：</span><span className="value">{basicInfoData.CI_OrderID}</span></Col>
                            <Col span={column} className="gutter-row" ><span>事发时间：</span><span className="value">{basicInfoData.CI_EventTime}</span></Col>
                            <Col span={column} className="gutter-row" ><span>事发地区：</span><span className="value">{basicInfoData.EventAreaName}</span></Col>
                            <Col span={column} className="gutter-row" ><span>详细地址：</span><span className="value">{basicInfoData.EventDetailAddress}</span></Col>

                            <Col span={24} className="gutter-row"  ><span>具体内容：</span><span className="value" style={{ display: 'inline-flex' }}>{this.onRenderContent(basicInfoData.CI_Content)}</span></Col>
                            <Col span={24} className="gutter-row" ><span>附件：</span><span className="value">{this.onReloadAttachs(basicInfoData.CI_Attachs)}</span></Col>
                        </Row>
                        {/* 图片预览 */}
                        <PhotoView imgData={this.state.basic_previewData} ref={(demo) => { basic_previewRef = demo }} />
                    </div> : ''}
            </div>
        );
    }
}

//流转信息
class TransferInfo extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            caseID: this.props.CaseID,
            transferInfoData: null,
            transferInfoDetailData: null,
            viewType: '简略信息'
        }
    }
    handleChange = (e) => {
        this.setState({ viewType: e.target.value })
    }
    componentWillReceiveProps(nextProps) {
        this.setState({ caseID: nextProps.CaseID })
        if (_activeKey == '2')
            setTimeout(function () { _TransferInfo.loadData(); }, 0);
    }
    componentWillMount() {
        //if (_activeKey == '2')
        //this.loadData();
    }
    componentDidMount() {
        _TransferInfo = this;
    }
    loadData() {
        ////console.log('caseID', _TransferInfo.state.caseID)
        this.setState({ transferInfoData: null, transferInfoDetailData: null })
        let t = JSON.parse(localStorage.userInfo)
        let token = t.token
        $.ajax({
            url: data_Url + 'WisdomAPI.ashx',
            type: "post",
            headers: {
                "token": token
            },
            dataType: "jsonp",
            jsonp: "callback",
            ansyc: false,
            cache: false,
            timeout: 360000,
            jsonpCallback: "successcallback",
            data: {
                doType: "GetCirculationRecordByID",
                ID: _TransferInfo.state.caseID
            },
            success: function (result) {
                let TransferInfodata = result.Rows;
                if (TransferInfodata != null && TransferInfodata != '') {
                    _TransferInfo.setState({ transferInfoDetailData: TransferInfodata })
                    _TransferInfo.setState({ transferInfoData: TransferInfodata[TransferInfodata.length - 1] })
                }
            },
            error: function () {

            }
        })
    }
    onReloadAttachs(files) {
        console.log('682', files)
        if (files != null && files != '') {
            const attachfiles = files.split(';');
            return (attachfiles.map(function (item, index) {
                return <a key={index} href={item} target='_blank' style={{ display: item.toString() == '' ? 'none' : 'inline' }} > <img src='../images/attach.png' style={{ width: 20, marginLeft: 10 }} /> 附件{index + 1}</a >
            }))
        }
    }
    fileName(url, array) {
        url = url || "";
        let fileName = "";
        if (url) {
            array.forEach(keys => {
                if (url.indexOf(keys) > -1) {
                    fileName = url.substring(url.split('').map((item, index) => { if (item == '/') { return index } }).filter(item => { if (item) { return item } })[url.split('').map((item, index) => { if (item == '/') { return index } }).filter(item => { if (item) { return item } }).length - 1] + 1, url.indexOf(keys) - 1) + '.' + keys
                }
            })
        }
        return fileName;
    }
    render() {
        this.columns = [{
            title: '操作部门',
            dataIndex: 'OutName',
            width: '20%',
        }, {
            title: '操作人',
            dataIndex: 'InName',
            width: '8%',
            render:(text, record, index)=>{
            return (<div>{record.OutName=='系统自动'?'':record.InName}</div>)
            }
        }, {
            title: '操作时间',
            dataIndex: 'JoinDate',
            width: '17%',
        }, {
            title: '操作方式',
            dataIndex: 'CrState',
            width: '15%',
        }, {
            title: '备注',
            dataIndex: 'CR_Reason',
            width: '40%',
            render: (text, record, index) => {
                if (record.CR_State == '11') {
                    return <a onClick={v => this.newUrl(record)}>{record.CR_Reason}</a>
                } else if (record.CR_State == '33' || record.CR_State == '50') {
                    const content = record.CR_Reason.split('臡');
                    let html = (content.map(function (item, index) {
                        return <p> {item} </p>
                    })
                    )
                    var file = ''
                    var filePart = []
                    if (record.CR_Attachs != null && record.CR_Attachs != '' && record.CR_Attachs != ' ') {
                        file = record.CR_Attachs.split(';');
                        filePart = file.map(function (item, index) {
                            return <a href={item} target="_blank"> {_TransferInfo.fileName(item, ['doc', 'docx', 'xls', 'xlsx', 'pdf', 'jpg', 'jpeg', 'png', 'bmp', 'txt', 'JPG', 'gif', 'GIF', 'svg', 'rm', 'rmvb', 'mpeg', 'avi', 'mp4', '3gp', 'flv', 'wmv', 'swf', 'mpg', '3gp2', 'asf', 'mpeg1', 'mpeg2', 'mpeg3', 'mpeg4', 'h264', 'flv1', 'ppt', 'pptx', 'vsd', 'pot', 'pps', 'rtf', 'wps', 'et', 'dps', 'txt', 'epub', 'rar', 'rar5', 'zip', '7z','BMP','JFIF','bmp','jfif','ico','tif','webp'])} </a>
                        })
                    }
                    return <div>{html}附件：{filePart}</div>

                } else if (record.CR_State == '16' || record.CR_State == '17') {
                    if (record.CR_Reason != null && record.CR_Reason != '') {
                        if (record.CrState == '重新办理') {
                            const content = record.CR_Reason.split('臡');
                            return (content.map(function (item, index) {
                                return <p> {item} </p>
                            })
                            )
                        } else {
                            return <p> {record.CR_Reason}  <span>{record.CR_RealCode}</span></p>
                        }


                    } else {
                        return <div>-</div>
                    }
                } else {
                    if (record.CR_Reason != null && record.CR_Reason != '') {
                        const content = record.CR_Reason.split('臡');
                        return (content.map(function (item, index) {
                            return <p> {item} </p>
                        })
                        )
                    } else {
                        return <div>-</div>
                    }
                }

            }
        }]
        const { transferInfoData, transferInfoDetailData } = this.state;
        return (
            <div>
                {
                    transferInfoData != null ?
                        <div>
                            {/* <Row>
                                <Col span={column} style={{ marginTop: 10, fontWeight: 'bold', fontSize: 14 }}><span>最新明细</span><a></a></Col>
                            </Row>
                            <Row>
                                <Col span={column} className="gutter-row" ><span>转出方：</span><span className="value">{transferInfoData.OutName}</span></Col>
                                <Col span={column} className="gutter-row" ><span>转入方：</span><span className="value">{transferInfoData.InName}</span></Col>
                                <Col span={column} className="gutter-row" ><span>业务状态：</span><span className="value">{transferInfoData.CI_State}</span></Col>
                                <Col span={column} className="gutter-row" ><span>流转类型：</span><span className="value">{transferInfoData.CrState}</span></Col>
                                <Col span={24} className="gutter-row" ><span>流转内容：</span><span className="value">{transferInfoData.CR_Reason}</span></Col>
                            </Row> */}
                            <Row>
                                <Col span={column} style={{ marginTop: 15, fontWeight: 'bold', fontSize: 14 }}><span>流程日志</span><a></a></Col>
                            </Row>
                            <Table columns={this.columns}
                                dataSource={transferInfoDetailData != null ? transferInfoDetailData : null}
                                style={{ paddingTop: 10 }}
                                size="middle"
                                pagination={false}
                                bordered
                            />
                        </div> : ''
                }
            </div>
        );
    }
}

//办理信息
var deal_previewRef = null
class DealInfo extends React.Component {

    constructor(props) {
        super(props);
        this.state = {
            caseID: this.props.CaseID,
            companyDealInfoData: null,
            viewType: isCompromise == '和解' ? '企业办理' : '部门办理',
            deal_previewData:[], // 预览图片地址数据
        }
    }
    handleChange = (e) => {
        this.setState({ viewType: e.target.value })
    }
    componentWillReceiveProps(nextProps) {
        this.setState({ caseID: nextProps.CaseID })
        
        if (_activeKey == '3')
            setTimeout(function () { _DealInfo.loadData(); }, 0);
    }
    componentWillMount() {
        //if (_activeKey == '3')
        //this.loadData();
    }
    componentDidMount() {
        _DealInfo = this;
    }
    onReloadAttachs(files) {
        // if (files != null && files != '') {
        //     const attachfiles = files.split(';');
        //     return (attachfiles.map(function (item, index) {
        //         return <a key={index} href={item} target='_blank' style={{ display: item.toString() == '' ? 'none' : 'inline' }} > 附件{index + 1}</a >
        //     }))
        // }

        const imgType = ['png', 'jpg', 'jpeg', 'bmp', 'gif']
        if (files != null && files != '') {
            const attachfiles = files.split(';');
            return (attachfiles.map((item, index) => {
                let flieArr = item.split('.');
                if (imgType.indexOf(flieArr[flieArr.length - 1].toLowerCase()) != -1) {
                    return <span style={{ color: "#038374", cursor: "pointer", display: item.toString() == '' ? 'none' : 'inline' }} key={index} onClick={() => this.imgClick(attachfiles)} > 附件{index + 1} </span >
                } else {
                    return <a key={index} href={item} target='_blank' style={{ display: item.toString() == '' ? 'none' : 'inline' }} > 附件{index + 1} </a >
                }
            }))
        }
    }
    imgClick = (attachfiles) => {
        this.setState({
            deal_previewData: attachfiles
        }, () => {
            deal_previewRef.show()
        })
    }
    loadData() {
        ////console.log('_DealInfocaseID', _DealInfo.state.caseID)
        console.log('611',this.state.caseID)
        if (this.state.caseID != 0) {
            //企业办理
            let t = JSON.parse(localStorage.userInfo)
        let token = t.token
            $.ajax({
                url: data_Url + 'WisdomAPI.ashx',
                type: "post",
                headers: {
                    "token": token
                },
                dataType: "jsonp",
                jsonp: "callback",
                ansyc: false,
                jsonpCallback: "successcallback",
                data: {
                    doType: "GetCaseCompanyPeaceByID",
                    ID: _DealInfo.state.caseID
                },
                success: function (result) {
                    ////console.log('peacedata', result);
                    if (result != null && result != '') {
                        _DealInfo.setState({ companyDealInfoData: result })
                    }
                    else {
                        _DealInfo.setState({ companyDealInfoData: null })
                    }
                },
                error: function () {

                }
            })
        }
    }
    render() {
        return (
            <div>
                {(this.state.companyDealInfoData != null) ?
                    <div>   {/*企业办理 投诉*/}
                        <Row>
                            <Col span={column} style={{ marginTop: 10, fontWeight: 'bold', fontSize: 14 }}><span>反馈信息</span><a></a></Col>
                        </Row>
                        <Row>
                            <Col span={column} className="gutter-row" ><span>和解结果：</span><span className="value">{this.state.companyDealInfoData.CP_Result}</span></Col>
                            <Col span={column} className="gutter-row" ><span>办理时间：</span><span className="value">{this.state.companyDealInfoData.JoinDate.substring(0,16)}</span></Col>
                            <Col span={column} className="gutter-row" ><span>争议金额(元)：</span><span className="value">{this.state.companyDealInfoData.CP_DisputeMoney}</span></Col>

                            <Col span={column} className="gutter-row" ><span>退赔金额(元)：</span><span className="value">{this.state.companyDealInfoData.CP_RedeemLoss}</span></Col>
                            
                            <Col span={column} className="gutter-row" ><span>经办人：</span><span className="value">{this.state.companyDealInfoData.CP_HanderName}</span></Col>
                            <Col span={column} className="gutter-row" ><span>经办人电话：</span><span className="value">{this.state.companyDealInfoData.CP_HanderPhone}</span></Col>

                            <Col span={column} className="gutter-row" ><span>负责人：</span><span className="value">{this.state.companyDealInfoData.CP_HeaderName}</span></Col>
                            <Col span={column} className="gutter-row" ><span>负责人电话：</span><span className="value">{this.state.companyDealInfoData.CP_HeaderPhone}</span></Col>

                            <Col span={24} className="gutter-row" ><span>反馈内容：</span><span className="value">{this.state.companyDealInfoData.CP_Content}</span></Col>

                            <Col span={24} className="gutter-row" ><span>附件：</span><span className="value">{this.onReloadAttachs(this.state.companyDealInfoData.CP_Attachs)}</span></Col>
                        </Row>
                        {(this.state.companyDealInfoData.CP_Result=='和解成功'&&this.state.companyDealInfoData.CI_Type!='投诉')?<Row>
                            <Col span={column} style={{ marginTop: 10, fontWeight: 'bold', fontSize: 14 }}><span>垫付信息</span><a></a></Col>
                        </Row>:''}
                        {(this.state.companyDealInfoData.CP_Result=='和解成功'&&this.state.companyDealInfoData.CI_Type!='投诉')?<Row>
                            <Col span={column} className="gutter-row" ><span>申请先行垫付：</span><span className="value">{this.state.companyDealInfoData.CP_IsPay=='1'?'是':'否'}</span></Col>
                            {this.state.companyDealInfoData.CP_IsPay=='1'?<Col span={column} className="gutter-row" ><span>垫付金额：</span><span className="value">{this.state.companyDealInfoData.CP_PayAmount}</span></Col>:''}
                            {this.state.companyDealInfoData.CP_IsPay=='1'?<Col span={24} className="gutter-row" ><span>附言：</span><span className="value">{this.state.companyDealInfoData.Comment}</span></Col>:''}
                        </Row>:''}
                        {/* 图片预览 */}
                        <PhotoView imgData={this.state.deal_previewData} ref={(demo) => { deal_previewRef = demo }} />
                    </div> : <Row><Col span={24} className="gutter-row" ><span>暂无数据</span></Col></Row>}
            </div>
        );
    }
}

//其它内容
class OthersInfo extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            caseID: this.props.CaseID,
            CasePressData: null,
            RelaInfoData: null,
            CaseSignData: null,
            viewType: '催办信息',
            UserType: '',//UserType:0 部门 1 企业
            data: [],
            pagination: {},
            loading: false,
            pagetotalCount: 0,
        }
    }
    handleChange = (e) => {
        this.setState({ viewType: e.target.value })
    }
    componentWillReceiveProps(nextProps) {
        this.setState({ caseID: nextProps.CaseID, viewType: '催办信息' })
        if (_FlowCommon.state.activeKey == '4')
            setTimeout(function () { _OthersInfo.loadData(); }, 10);
    }
    componentWillMount() {
        //this.setState({ viewType: '催办信息' })
        //if (_activeKey == '4') {
        //    this.loadData();
        //}
    }
    componentDidMount() {
        _OthersInfo = this;
    }
    handleTableChange = (pagination, filters, sorter) => {
        const pager = { ...this.state.pagination };
        var ciType = '';
        try { ciType = filters.CI_Type.toString(); }
        catch (e) { }
        pager.current = pagination.current;
        this.setState({
            pagination: pager,
        });
        this.fetch({
            pagesize: pagination.pageSize,
            pageno: pagination.current,
            sortField: sorter == null ? "" : sorter.field,
            sortOrder: sorter == null ? "" : sorter.order,
            CI_Type: ciType == null ? "" : ciType,
        });
    }
    fetch = (params = {}) => {
        this.setState({ loading: true });
        ////console.log('params:', ...params.sortOrder);
        $.ajax({
            url: data_Url + 'GetPageData.ashx?DoType=GetComRelaCaseList&randam=' + new Date().getTime(),
            method: 'get',
            data: {
                ID: _OthersInfo.state.caseID,
                ComUserCode: EventJS.getUserInfo().CU_Code,
                ...params,
            },
            type: 'json',
            success: function (data) {
                ////console.log('data', data);

                const strdata = data != null ? JSON.parse(data) : null;
                const pagination = { ..._OthersInfo.state.pagination };
                // Read total count from server
                // pagination.total = data.totalCount;
                pagination.total = strdata.totalCount;
                //pagination.pageSize = 5;
                _OthersInfo.setState({ pagetotalCount: strdata.totalCount })

                pagination.showSizeChanger = true;
                pagination.showQuickJumper = true;
                _OthersInfo.setState({
                    loading: false,
                    data: strdata.Rows,
                    pagination,
                });
            }
        });
    }
    loadData() {
        this.setState({ CasePressData: null })
        if (this.state.caseID != 0) {
            //根据ID查询催办历史信息
            let t = JSON.parse(localStorage.userInfo)
        let token = t.token
            $.ajax({
                url: data_Url + 'WisdomAPI.ashx',
                type: "post",
                headers: {
                    "token": token
                },
                dataType: "jsonp",
                jsonp: "callback",
                ansyc: false,
                jsonpCallback: "successcallback",
                data: {
                    doType: "GetCasePressByID",
                    ID: _OthersInfo.state.caseID
                },
                success: function (result) {
                    ////console.log('pressdata', result);
                    if (result != null && result != '') {
                        _OthersInfo.setState({ CasePressData: result.Rows })
                    } else {
                        _OthersInfo.setState({ CasePressData: null })
                    }
                },
                error: function () {

                }
            })

            this.fetch();
        }
    }
    //点击显示登记编号弹框
    showdetail = (record) => {
        //this.props.dispatch(evn.showCaseInfo(record.ID, 'CompanyCase'))
        //history.push({
        //    pathname: '/New/CaseDetailsInfo?cid=' + record.ID + '&fromType=' + fromType,
        //})
        let url = window.location.href.split("#")[0] + "#/New/CaseDetailsInfoView?cid=" + record.ID + "&fromType=" + fromType;
        window.open(url)
    }
    render() {
        const { CasePressData, RelaInfoData } = this.state;
        var filters = [{
            text: '投诉',
            value: '投诉',
        }, {
            text: '举报',
            value: '举报',
        }]
        const casePressColumns = [{
            title: '催办人',
            dataIndex: 'UserName',
        }, {
            title: '催办部门',
            dataIndex: 'UserDeptName',
        }, {
            title: '催办时间',
            dataIndex: 'JoinTime',
        }, {
            title: '催办内容',
                dataIndex: 'CP_Content',
                width: 450,
                render: (text, record, index) => {
                    return (
                        <Tooltip placement="top" title={record.CP_Content}>
                        <div className='row2Ellipsis'>
                             {record.CP_Content}
                        </div>
                    </Tooltip> 
                    )
                },
        }]
        this.companycolumns = [{
            title: '登记编号',
            dataIndex: 'CI_Code',
            render: (text, record, index) => {
                return (
                    <div>
                        <a style={{ marginRight: 10 }} onClick={v => this.showdetail(record)}>{record.CI_Code}</a>
                    </div>
                )
            },
        }, {
                title: '投诉人姓名',
            dataIndex: 'CI_UserName',
        }, {
            title: '联系电话',
            dataIndex: 'CI_UserPhone',
        }, {
            title: '登记时间',
            dataIndex: 'RegTime',
            }, {
                title: '处理结果',
                dataIndex: 'CP_Result',
            }]

        return (
            <div>
                <Row>
                    <Col className="gutter-row" style={{ textAlign: 'center' }} span={24}>
                        <Radio.Group defaultValue={this.state.viewType} value={this.state.viewType} onChange={this.handleChange}>
                            <Radio.Button value="催办信息">催办信息</Radio.Button>
                            <Radio.Button value="关联业务">关联业务</Radio.Button>
                        </Radio.Group>
                    </Col>
                </Row>
                <div style={{ display: (this.state.viewType == "催办信息" ? "block" : "none") }}>   {/*催办业务*/}
                    <Row style={{ marginTop: 10 }}>
                        <Table columns={casePressColumns}
                            rowKey={record => record.ID}
                            dataSource={CasePressData}
                            pagination={false}
                            loading={this.state.loading}
                            size="middle"
                            bordered
                            locale={tabletext}
                            style={{ width: '100%' }}
                        />
                    </Row>
                </div>
                <div style={{ display: (this.state.viewType == "关联业务" ? "block" : "none") }}>   {/*企业处理关联业务table*/}
                    <div style={{ padding: 10, marginTop: 10 }}>
                        {/* 共搜索到 <span>{this.state.pagetotalCount}</span> 条数据，*/}
                        <span style={{ fontWeight: 'bold', fontSize: 15 }}>关联投诉</span> 以下内容是以投诉人联系电话精确匹配的历史投诉
                        </div>
                    <Table columns={this.companycolumns}
                        rowKey={record => record.ID}
                        dataSource={this.state.data}
                        pagination={this.state.pagination}
                        loading={this.state.loading}
                        onChange={this.handleTableChange}
                        expandedRowRender={record => record.CP_Result != '' ? <p><div>投诉内容：{record.CI_Content}</div><div>反馈内容：{record.CP_Content}</div></p> : undefined}
                        size="middle"
                        bordered
                        locale={tabletext}
                    />
                </div>

            </div>
        );
    }

}

//日志留痕
class LogoInfo extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            caseID: this.props.CaseID,
            logoData: null,
            infoResult:null,
            viewType: '日志记录'
        }
    }
    handleChange = (e) => {
        this.setState({ viewType: e.target.value })
    }
    componentWillReceiveProps(nextProps) {

        this.setState({ caseID: nextProps.CaseID })
        if (_activeKey == '5')
            setTimeout(function () { _LogoInfo.loadData();_LogoInfo.infoResult(); }, 10);
    }
    componentWillMount() {
        //if (_activeKey == '2')
        //this.loadData();
    }
    componentDidMount() {
        _LogoInfo = this;
    }
    loadData() {
        this.setState({ logoData: null })
        $.ajax({
            url: Hcurl + '/CaseLog/GetCaseOperationLog?Log_CaCode=' + cicode +'&Log_UserType=2',
            type: "get",
            headers: {
                "token": EventJS.getUserInfo().token
            },
            success: function (result) {
                // console.log('logoData', result);
                if (result != null && result != '') {
                    _LogoInfo.setState({ logoData: result })
                } else {
                    _LogoInfo.setState({ logoData: null })
                }
            },
            error: function () {
                history.push({ "pathname": "/Login/LoginMain/LoginEntry" })
            }
        })
    }
    infoResult() {
        this.setState({ infoResult: null })
        // +'&Log_UserType=2'
        $.ajax({
            url: Hcurl + '/CaseLog/GetCaseMessageLog?caCode=' + cicode,
            type: "get",
            headers: {
                "token": EventJS.getUserInfo().token
            },
            success: function (result) {
                console.log('infoResult', result);
                if (result != null && result != '') {
                    _LogoInfo.setState({ infoResult: result })
                } else {
                    _LogoInfo.setState({ infoResult: null })
                }
            },
            error: function () {
                history.push({ "pathname": "/Login/LoginMain/LoginEntry" })
            }
        })
    }
    render() {
        this.columns = [{
            title: '操作人',
            dataIndex: 'JoinMan',
            fixed: 'left',
            width: 120,
        }, {
            title: 'IP地址',
            dataIndex: 'Log_UserIP',
        }, {
            title: '操作时间',
            dataIndex: 'JoinDate',
            render:(text, record, index)=>{
            return (<div>{record.JoinDate.substring(0,16)}</div>)
            }
        }, {
            title: '操作方式',
            dataIndex: 'Log_Method',
        }, {
            title: '备注',
            dataIndex: 'Log_Content',
                fixed: 'right',
                width: 400,
            render: (text, record, index) => {
                const content = record.Log_Content.split('臡');
                return (content.map(function (item, index) {
                    return <p key={index}> {item} </p>
                })
               )
            },
        }];

        this.columnsResult = [{
            title: '操作人',
            dataIndex: 'JoinMan',
            fixed: 'left',
            width: 120,
        }, {
            title: 'IP地址',
            dataIndex: 'Log_UserIP',
        },{
            title: '推送时间',
            dataIndex: 'Log_Time',

        }, {
            title: '推送至',
            dataIndex: 'Log_Method',
            // fixed: 'right',
        }, {
            title: '推送内容',
            dataIndex: 'Log_Content',
            // fixed: 'right',
        }];
        const { logoData } = this.state;
        const { infoResult } = this.state;
        return (

            <div>
                <Row>
                    <Col className="gutter-row" style={{ textAlign: 'center' }} span={24}>
                        <Radio.Group defaultValue={this.state.viewType} value={this.state.viewType} onChange={this.handleChange}>
                            <Radio.Button value="日志记录">日志记录</Radio.Button>
                            <Radio.Button value="信息推送">信息推送</Radio.Button>
                        </Radio.Group>
                    </Col>
                </Row>
                <div style={{ display: (this.state.viewType == "日志记录" ? "block" : "none") }}>   {/*催办业务*/}
                    <Row style={{ marginTop: 10 }}>
                        <Table columns={this.columns}
                        rowKey={record => record.ID}
                        dataSource={logoData}
                        style={{ paddingTop: 10 }}
                        size="middle"
                        bordered
                        scroll={{ x: 1200 }}
                        locale={tabletext}
                        pagination={false}
                    />
                    </Row>
                </div>
                <div style={{ display: (this.state.viewType == "信息推送" ? "block" : "none") }}>   {/*催办业务*/}
                    <Row style={{ marginTop: 10 }}>
                        <Table columns={this.columnsResult}
                        rowKey={record => record.ID}
                        dataSource={infoResult}
                        style={{ paddingTop: 10 }}
                        size="middle"
                        bordered
                        scroll={{ x: 1200 }}
                        locale={tabletext}
                        pagination={false}
                    />
                    </Row>
                </div>
            </div>
        );
    }
}

//拒绝和解
class RefusInfo extends React.Component {

    constructor(props) {
        super(props);
        this.state = {
            caseID: this.props.CaseID,
            refusData: null
        }
    }
    handleChange = (e) => {
        this.setState({ viewType: e.target.value })
    }
    componentWillReceiveProps(nextProps) {

        this.setState({ caseID: nextProps.CaseID })
        //if (_activeKey == '3')
        //    setTimeout(function () { _RefusInfo.loadData(); }, 0);
    }
    componentWillMount() {
        //if (_activeKey == '3')
        //this.loadData();
    }
    componentDidMount() {
        _RefusInfo = this;
    }

    render() {
        return (
            <div>
                <Row>
                    <Col span={column} style={{ marginTop: 10, fontWeight: 'bold', fontSize: 14 }}><span>拒绝和解</span><a></a></Col>
                </Row>
                <Row>
                    <Col span={column} className="gutter-row" ><span>操作人：</span><span className="value">{baseInfoData.DealUserName}</span></Col>
                    <Col span={column} className="gutter-row" ><span>操作电话：</span><span className="value">{baseInfoData.DealUserPhone}</span></Col>
                    <Col span={column} className="gutter-row" ><span>操作时间：</span><span className="value">{baseInfoData.NoAcceptTime.substring(0,16)}</span></Col>
                    <Col span={24} className="gutter-row" ><span>拒绝原因：</span><span className="value">{baseInfoData.CI_NotAcceptReson}</span></Col>
                </Row>

            </div>
        );
    }
}

const mapStateToProps = (state) => {
    ////console.log('state', state)
    return {
        caseId: state.CaseDetailsInfo.caseId,
        fromType: state.CaseDetailsInfo.fromType
    }
};
export default connect(mapStateToProps)(App)


// WEBPACK FOOTER //
// ./src/components/Content/Common/CaseDetailsInfo.js